import { getRegionsByCountryDict } from "./AuthUtils";
import { AppThunk } from "../../Store";
import { Api, LogService } from "../../../Services";
import { GENERIC_ERROR_KEY } from "../../../Constants";
import { Actions } from "./AuthSlice";
import { GeneralState, SavedItemsState } from "..";
import { UpdateProfileRequest, Languages } from "../../../Models";
import { useSelector } from "react-redux";

export const initRegistrationData = (): AppThunk => async (dispatch: any) => {
  try {
    const registrationData = await Api.Utils.registrationData();
    if (registrationData && registrationData.statusCode === 200 && registrationData.data) {
      await dispatch(
        Actions.setRegistrationData({
          countries: registrationData.data.countries,
          regionsByCountry: getRegionsByCountryDict(registrationData.data.regions),
          specializations: registrationData.data.specializations,
          mainInterests: registrationData.data.mainInterests,
        }),
      );
    } else {
      LogService.logError(`Registration data request had failed. Response: ${registrationData}`);
    }
  } catch (ex) {
    LogService.logError(`Exception occurred in initRegistrationData: ${ex}`);
  }
};
export const register =
  (
    fullName: string,
    email: string,
    country: string,
    region: string | undefined,
    specialization: string,
    mainInterest: string,
    password: string,
    acceptTerms: boolean,
  ): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setRegistrationInProgress());
      const response = await Api.Auth.register({
        fullName,
        email,
        country,
        region,
        specialization,
        mainInterest,
        password,
        acceptTerms,
      });
      if (response && response.statusCode === 200) {
        await dispatch(Actions.setRegistrationCompleted(email));
      } else {
        await dispatch(Actions.setRegistrationFailed(response?.error || GENERIC_ERROR_KEY));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in register: ${ex}`);
      await dispatch(Actions.setRegistrationFailed(GENERIC_ERROR_KEY));
    }
  };
export const approveEmail =
  (userId: string, token: string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setEmailConfirmationInProgress());
      const response = await Api.Auth.confirmEmail(userId, token);
      if (response && response.statusCode === 200) {
        await dispatch(Actions.setEmailConfirmationSuccess());
      } else {
        await dispatch(Actions.setEmailConfirmationError(response?.error || GENERIC_ERROR_KEY));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in approveEmail: ${ex}`);
      await dispatch(Actions.setEmailConfirmationError(GENERIC_ERROR_KEY));
    }
  };
export const resendEmail =
  (emailId: string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setEmailResendInProgress(true));
      await Api.Auth.resendEmail(emailId);
    } catch (ex) {
      LogService.logError(`Exception occurred in resendEmail: ${ex}`);
    }
    await dispatch(Actions.setEmailResendInProgress(false));
  };
//const language: Languages | string = useSelector(GeneralState.Selectors.selectActiveLanguage);
export const login =
  (email: string, password: string, keepMeLoggedIn: boolean, lang: Languages | string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setLoginInProgress());
      const response = await Api.Auth.login({
        userName: email,
        password: password,
        rememberMe: keepMeLoggedIn,
      });
      if (response && response.data && response.statusCode === 200) {
        await dispatch(GeneralState.Thunks.initMainAppData());
        await dispatch(SavedItemsState.Thunks.getAllSavedItems());
        await dispatch(Actions.setLoginCompleted());
        console.log(" before select lan");
        if (lang !== response.data.language) await dispatch(GeneralState.Thunks.setLanguage(lang));
        await dispatch(
          GeneralState.Actions.setUser({
            user: response.data,
            rememberMe: keepMeLoggedIn,
          }),
        );
        await dispatch(GeneralState.Actions.setIsAgri(response.data.role == "OpenFieldAgriculture"));
      } else {
        console.log("login failed");
        await dispatch(Actions.setLoginFailed(response?.error || GENERIC_ERROR_KEY));
      }
    } catch (ex) {
      console.log("login failed");
      LogService.logError(`Exception occurred in login: ${ex}`);
      await dispatch(Actions.setLoginFailed(GENERIC_ERROR_KEY));
    }
  };
export const forgotPassword =
  (email: string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setLoginInProgress());
      const response = await Api.Auth.forgotPassword(email);
      if (response && response.data && response.statusCode === 200) {
        await dispatch(Actions.setLoginCompleted());
        return response;
      } else {
        await dispatch(Actions.setLoginFailed(response?.error || GENERIC_ERROR_KEY));
        return response;
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in forgot password: ${ex}`);
      await dispatch(Actions.setLoginFailed(GENERIC_ERROR_KEY));
    }
  };
export const validateResetPasswordTokenThunk =
  (email: string, token: string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setUpdatePasswordInProgress());
      const response = await Api.Auth.validateResetPasswordToken(email, token);
      if (response && response.data && response.statusCode === 200) {
        await dispatch(Actions.setUpdatePasswordTokenCompleted());
      } else {
        await dispatch(Actions.setUpdatePasswordFailed(response?.error || GENERIC_ERROR_KEY));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in forgot password: ${ex}`);
      await dispatch(Actions.setLoginFailed(GENERIC_ERROR_KEY));
    }
  };
export const updatePasswordThunk =
  (username: string, token: string, password: string): AppThunk =>
  async (dispatch: any) => {
    try {
      await dispatch(Actions.setUpdatePasswordInProgress());
      const response = await Api.Auth.updatePassword(username, token, password);
      if (response && response.data && response.statusCode === 200) {
        await dispatch(Actions.setUpdatePasswordCompleted());
      } else {
        await dispatch(Actions.setUpdatePasswordFailed(response?.error || GENERIC_ERROR_KEY));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in forgot password: ${ex}`);
      await dispatch(Actions.setLoginFailed(GENERIC_ERROR_KEY));
    }
  };
export const updateUserProfileThunk =
  (request: UpdateProfileRequest, keepMeLoggedIn: boolean): AppThunk =>
  async (dispatch: any) => {
    try {
      const response = await Api.Users.updateUserProfile(request);
      if (response && response.data && response.statusCode === 200) {
        dispatch(
          GeneralState.Actions.setUser({
            user: response.data,
            rememberMe: keepMeLoggedIn,
          }),
        );
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in forgot password: ${ex}`);
    }
  };
